module.exports = require("./fr-VU.js");